// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"213fedcd","458":"213fedcd","741":"405227da"}[chunkId] + ".chunk.css";
};